<template>
  <div class="page">
    <template v-if="showLoading">
      <div></div>
    </template>
    <template v-else-if="showDetail">
      <van-form :class="{formList:true,formBottom:showBottomBtn}" ref="formList">
        <div class="card">
          <van-field
              v-model="form.orderNum"
              name="orderNum"
              label="订单数"
              readonly
              input-align="right"
              label-class="label-class"
              @click-input="handleOrderNumClick"
          >
            <template #label>
              <div style="color: #3A3B3C">
                含
                <span :style="{color: isTea? '#97D700' : '#A52337'}">
              {{ form.orderNum }}
              </span>
                个订单
              </div>
            </template>
            <template #input>
              <div>
                查看详情
                <i class="van-icon van-icon-arrow van-cell__right-icon"></i>
              </div>
            </template>
          </van-field>
        </div>
        <span class="card-title">
        发票信息
      </span>
        <div class="card">
          <van-field
              v-model="form.invoiceStatusStr"
              name="invoiceStatusStr"
              label="开票状态"
              readonly
              input-align="right"
              label-class="label-class"
          >
            <template v-if="form.invalidationReason" #right-icon>
              <div>
                <van-popover
                    v-model="showStatusPopover"
                    theme="dark"
                    placement="bottom-end"
                    trigger="click"
                >
                  <div style="max-width: 231px;">
                    <div class="tool-tip" style="padding: 12px">
                      {{ form.invalidationReason }}
                    </div>
                  </div>
                  <template #reference>
                    <van-icon name="warning-o" size="16" color="#999999"/>
                  </template>
                </van-popover>
              </div>
            </template>
          </van-field>
          <van-field
              class="invoiceMoney"
              v-model="form.mayInvoiceMoney"
              v-if="checkShowMoney(form.mayInvoiceMoney)"
              name="invoiceMoney"
              label="可开票金额"
              readonly
              input-align="right"
              label-class="label-class"
          >
            <template #input v-if="form.mayInvoiceMoney">
              <div :class="{'tea-price':isTea}" style="display: flex">
                ￥{{ form.mayInvoiceMoney }}
                <div style="margin-left: 5px">
                  <van-popover
                      v-model="showPopover"
                      theme="dark"
                      placement="bottom-end"
                      trigger="click"
                  >
                    <div style="max-width: 231px;">
                      <div class="tool-tip" style="padding: 12px">
                        {{ form.disclaimers }}
                      </div>
                    </div>
                    <template #reference>
                      <van-icon name="warning-o" size="16" color="#999999"/>
                    </template>
                  </van-popover>
                </div>
              </div>
            </template>
          </van-field>
          <van-field
              class="invoiceMoney"
              v-model="form.invoiceMoney"
              v-if="checkShowMoney(form.invoiceMoney)"
              name="invoiceMoney"
              label="开票金额"
              readonly
              input-align="right"
              label-class="label-class"
          >
            <template #input v-if="form.invoiceMoney">
              <div :class="{'tea-price':isTea}" style="display: flex">
                ￥{{ form.invoiceMoney }}
                <div style="margin-left: 5px">
                  <van-popover
                      v-model="showPopover"
                      theme="dark"
                      placement="bottom-end"
                      trigger="click"
                  >
                    <div style="max-width: 231px;">
                      <div class="tool-tip" style="padding: 12px">
                        {{ form.disclaimers }}
                      </div>
                    </div>
                    <template #reference>
                      <van-icon name="warning-o" size="16" color="#999999"/>
                    </template>
                  </van-popover>
                </div>
              </div>
            </template>
          </van-field>
          <van-field
              v-model="form.invoiceHeader"
              v-if="form.invoiceHeader"
              name="invoiceHeader"
              type="textarea"
              rows="1"
              autosize
              label="发票抬头"
              readonly
              input-align="right"
              label-class="label-class"
          />
          <van-field
              v-model="form.companyHeader"
              v-if="form.companyHeader"
              name="companyHeader"
              label="公司抬头"
              type="textarea"
              rows="1"
              autosize
              readonly
              input-align="right"
              label-class="label-class"
          />
          <van-field
              v-model="form.companyTaxNumber"
              v-if="form.companyTaxNumber"
              name="companyTaxNumber"
              label="公司税号"
              readonly
              input-align="right"
              label-class="label-class"
          />
          <van-field
              v-model="form.applyTimeStr"
              name="applyTimeStr"
              label="申请时间"
              readonly
              input-align="right"
              label-class="label-class"
          />
          <van-field
              v-model="form.invoiceNo"
              name="invoiceNo"
              label="申请编号"
              readonly
              input-align="right"
              label-class="label-class"
          >
            <template #button>
              <copy-btn :text="form.invoiceNo"/>
            </template>
          </van-field>

          <van-field
              v-if="form.registeredAddress"
              v-model="form.registeredAddress"
              name="registeredAddress"
              type="textarea"
              rows="1"
              autosize
              label="注册地址"
              readonly
              input-align="right"
              label-class="label-class"
          />
          <van-field
              v-if="form.tel"
              v-model="form.tel"
              name="tel"
              label="电话号码"
              readonly
              input-align="right"
              label-class="label-class"
          />

          <van-field
              v-if="form.bank"
              v-model="form.bank"
              name="bank"
              type="textarea"
              autosize
              rows="1"
              label="开户银行"
              readonly
              input-align="right"
              label-class="label-class"
          />

          <van-field
              v-if="form.bankAccount"
              v-model="form.bankAccount"
              name="bankAccount"
              type="textarea"
              autosize
              rows="1"
              label="银行账号"
              readonly
              input-align="right"
              label-class="label-class"
          />

        </div>
        <span class="card-title">
        接收方式
      </span>
        <div class="card">
          <van-field
              :class="{'email-line':true,'tc-email-line':isTea,'gray-text':!emailValidator}"
              v-model="form.email"
              name="email"
              type="textarea"
              autosize
              rows="1"
              label="邮箱地址"
              readonly
              input-align="right"
              label-class="label-class"
              :rules="[{validator:emailValidator,message:form.emailExceptionMessage || ''}]"
          >
            <template #button>
              <div v-if="showEmailEditIcon" class="ic-edit">
                <img class="img-icon" src="../../assets/invoice/ic_edit.png" alt="" @click="editBtnAction"/>
              </div>
            </template>
          </van-field>
          <van-field
              v-if="form.phone"
              v-model="form.phone"
              name="phone"
              label="联系电话"
              readonly
              input-align="right"
              label-class="label-class"
          >
          </van-field>
        </div>
      </van-form>
      <div v-if="showBottomBtn" class="bottom-view">
        <div :class="{'bitton-view':true,'tc-background-color':isTea}">
          <div class="buttom-view" :key="sendKey" @click.once="sendAgain">
            {{ bottomBtnTitle }}
          </div>
        </div>
      </div>
      <van-action-sheet v-model="showSheet" style="height: 248px;" :title="sheetTitle">
        <div :class="{'sheet-content':true, 'bottom-padding':!showKey}">
          <div class="input-box">
            <van-field
                v-model="tempEmail"
                ref="inputField"
                name="email"
                @keyup="handleKeyUp"
                @keydown="handleKeyDown"
                :border="true"
                clearable
                :disabled="editType === 2 && !emailEdit"
                input-align="left"
                @focus="emailFieldFocus"
                @blur="emailFieldBlur"
                label-class="label-class"
            >
              <template #right-icon v-if="editType === 2 && !emailEdit">
                <div class="img-icon">
                  <img class="img-icon" src="../../assets/invoice/ic_edit.png" alt="" @click="emailEdit=true"/>
                  <!--                  <van-icon name="edit" @click="emailEdit=true" />-->
                </div>
              </template>
            </van-field>
          </div>
          <div class="bloc-fit">
            <div class="btn-box">
              <van-button
                  type="primary"
                  round
                  :color="isTea ? '#97D700' : '#A52337'"
                  block
                  @click="emailConfirm"
              >确认
              </van-button>
            </div>
            <div class="suf-line" v-if="showSufLine">
              <div
                  class="suf-item"
                  v-for="(suf,index) in form.emailSuffixList"
                  :key="index"
                  @click="sufItemAction(suf)"
              >@{{ suf }}
              </div>
            </div>
            <div @scroll.stop="scrollHandler" class="email-list" v-if="emailList?.length > 0">
              <div class="email-list-item" v-for="(email,index) in emailList" :key="index"
                   @click="selectedEmail(email)">
                <span class="email-blod">{{ emailBold() }}</span>{{ emailGrey(email) }}
              </div>
            </div>
          </div>

        </div>
      </van-action-sheet>
      <van-dialog
          v-model="showDialog"
          :show-confirm-button="false"
          width="306px"
      >
        <template>
          <div class="edit-dialog">
            <div class="dialog-title">
              {{ form.invoiceEmailMultipleMessage }}
            </div>
            <div class="btn-line">
              <van-button
                  :loading="btn1Loading"
                  class="dialog-btn1"
                  type="default"
                  @click="dialogBtn1Action">
                {{ form.invoiceEmailSingleButtonMessage }}
              </van-button>
              <van-button
                  :loading="btn2Loading"
                  :class="{'dialog-btn2':true,'tc-background-color':isTea}"
                  type="default"
                  @click="dialogBtn2Action">
                {{ form.invoiceEmailMultipleButtonMessage }}
              </van-button>

            </div>
          </div>
        </template>
      </van-dialog>
    </template>
    <template v-else>
      <div class="empty-view" style="display: flex;flex-direction: column;align-items: center">
        <img class="empty-img" :src="emptyImg" alt="">
        <div class="empty-text">未查询到发票信息</div>
        <van-button
            class="login-button"
            v-if="showLoginBtn"
            type="primary"
            round
            :color="isTea ? '#97D700':'#A52337'"
            @click="loginAction"
        >立即登录
        </van-button>
      </div>
    </template>
  </div>
</template>

<script>
import {invoiceTaskInfo, resendEmail, updateInvoice} from "@/api/invoice";
import wx from "weixin-js-sdk";
import {isCottiApp, setPageTitle} from "@/utils";
import config from "@/utils/config";
import CopyBtn from "@/views/invoice/components/copy-btn.vue";
import {Toast} from "vant";

export default {
  name: "invoiceDetail",
  components: {CopyBtn},
  watch: {
    showSheet(val) {
      console.log('showSheet  val == ', val);
      if (!val) {
        this.sendKey++
        this.emailEdit = false;
      } else {
        this.emailEdit = !this.form.reSendBtn;
        this.tempEmail = this.form.email;
        if (this.editType === 1) {
          // 在DOM更新完成后设置焦点
          this.$nextTick(() => {
            this.$refs.inputField.focus();
          });
        }

      }
    }
  },
  computed: {
    showEmailEditIcon() {
      //   - 修改条件：申请单开票状态=已提交||待开票；
      // 开票状态 1.已提交；2.待开票；3.已开票；4.已取消；5.已作废
      return [1, 2].includes(this.form.invoiceStatus);
    },
    // 是否显示邮箱后缀行
    showSufLine() {
      return this.form.emailSuffixList && this.tempEmail?.length > 1 && !this.tempEmail?.includes('@')
    },
    emailList() {
      if (this.tempEmail?.length > 1 && this.tempEmail?.includes('@')) {

        const atIndex = this.tempEmail.indexOf('@');

        const emailPre = this.tempEmail.substring(0, atIndex);

        const tempList = this.form.emailSuffixList?.map(suf => {
          return emailPre + '@' + suf;
        });

        const emailList = tempList?.filter(e => {
          return e.includes(this.tempEmail);
        });

        if (emailList?.length === 1 && emailList[0] === this.tempEmail) {
          return [];
        }
        return emailList;
      }
      return [];
    },
    emptyImg() {
      return this.isTea ? 'https://cdn-product-prod.yummy.tech/wechat/teacat/images/empty/search_result.png' : require('../../assets/invoice_empty.png');
    },
    isTea() {
      return window.location.host.includes('teacat');
    },
    showBottomBtn() {
      return this.form.reSendBtn || this.form.invoiceEmailStatus === 1;
    },
    bottomBtnTitle() {
      if (this.form.invoiceEmailStatus === 1) {
        return '修改邮箱地址';
      }
      if (this.form.reSendBtn) {
        return '重新发送';
      }
      return '';
    },
    sheetTitle() {
      if (this.form.invoiceEmailStatus === 1) {
        return '修改邮箱地址';
      }
      if (this.form.reSendBtn) {
        return '请确认邮箱';
      }
      return '修改邮箱地址';
    }
  },
  data() {
    return {
      btn1Loading: false,
      btn2Loading: false,

      /// 弹窗类型的标记，
      // 1、编辑 自动获得焦点，不显示输入框后的编辑按钮；
      // 2、重新发送 输入框不可编辑，显示输入框后的编辑按钮；
      editType: null,

      // 标记邮箱 field 焦点
      emailFocus: null,

      showKey: false,
      showLoading: true,
      emailEdit: false,
      showLoginBtn: false,
      // 判断是否是微信平台
      isWeixinPlatform: false,
      sendKey: 0,
      showDetail: false,
      invoiceNo: null,
      token: this.$route.query.token,
      showPopover: false,
      showStatusPopover: false,
      showSheet: false,
      showDialog: false,
      // 编辑时的临时邮箱
      tempEmail: null,
      form: {
        ///订单数
        orderNum: 1,
        ///可开票金额
        mayInvoiceMoney: 0,
        /// 开票金额
        invoiceMoney: 0,
        /// 开票状态 开票状态 1.已提交；2.待开票；3.已开票；4.已取消；5.已作废
        invoiceStatus: 0,
        /// 开票状态
        invoiceStatusStr: "",
        /// 作废原因
        invalidationReason: "",
        // 申请时间
        applyTime: "",

        /// 申请时间
        applyTimeStr: "",
        // 申请编号
        invoiceNo: "",

        // 发票抬头
        invoiceHeader: "",
        // 公司抬头
        companyHeader: "",
        // 公司税号
        companyTaxNumber: "",
        // 邮箱地址
        email: "",
        // 联系电话
        phone: "",
        // 重新发送按钮标记
        reSendBtn: false,
        // 开票邮箱状态（0-邮箱正常；1-邮箱错误） flow-6226 发票1.1
        invoiceEmailStatus: 0,
        // 邮箱错误提示
        emailExceptionMessage: null,
        // 同批次申请单数目
        sameBatchTaskAmount: null,
        // 批次编号
        batchNo: null,


        // 同批次多申请单修改弹窗提示文案
        invoiceEmailMultipleMessage: null,
        // 仅当前申请单修改按钮文案
        invoiceEmailSingleButtonMessage: null,
        // 同批次多申请单修改按钮文案
        invoiceEmailMultipleButtonMessage: null,

        // 邮箱后缀字符串列表
        emailSuffixList: null,
      },
    };
  },
  async mounted() {
    this.invoiceNo = this.$route.query.invoiceNo;
    console.log('invoiceNo = ', this.$route.query)
    this.token = this.$route.query.u_t;
    this.isInMiniApp = await this.isMiniProgram();
    if (!this.token) {
      this.showDetail = false
      this.showLoginBtn = !isCottiApp();
    } else {
      this.getDetail();
    }
    setPageTitle('发票详情');
  },
  methods: {
    scrollHandler(val) {
      console.log('in scrollHandler val = ', val);
    },
    selectedEmail(email) {
      this.tempEmail = email;
    },
    emailBold() {
      return this.tempEmail;
    },
    emailGrey(email) {
      return email.substring(this.tempEmail?.length);
    },
    sufItemAction(key) {
      console.log('this.tempEmail 1 = ', this.tempEmail);
      this.tempEmail = this.tempEmail + '@' + key;

      console.log('this.tempEmail 2 = ', this.tempEmail);

    },
    dialogBtn1Action() {
      this.btn1Loading = true;

      this.editInvoiceEmail(this.form.invoiceNo, null);

    },
    dialogBtn2Action() {
      this.btn2Loading = true;

      this.editInvoiceEmail(null, this.form.batchNo);
    },
    emailValidator(value) {
      return !this.form.emailExceptionMessage;
    },
    handleKeyUp(val) {
      this.showKey = true;
    },
    handleKeyDown(val) {
      this.showKey = false;
    },
    emailFieldFocus(val) {
      console.log('in emailFieldFocus val = ', val);
      this.emailFocus = true;
    },
    emailFieldBlur(val) {
      console.log('in emailFieldBlur val = ', val);
      this.emailFocus = false;
    },
    checkShowMoney(m) {
      if (m === null || m === undefined) {
        return false;
      } else {
        return m >= 0;
      }
    },
    loginAction() {
      if (this.isInMiniApp) {
        wx.miniProgram.navigateTo({
          url: `/packages/common/login/index`,
        })
      } else {
        my.navigateTo({
          url: `/packages/common/login/index`,
          success: function (res) {
            console.log(res, '成功');
          },
          fail: function (err) {
            console.log(err);
          }
        });
      }
    },
    getDetail() {
      console.log('getDetail')
      console.log('invoiceNo = ', this.invoiceNo)
      if (!this.invoiceNo) return
      // this.$toast.loading({message: '加载中...',forbidClick: true, duration: 20000})
      invoiceTaskInfo({invoiceNo: this.invoiceNo}).then(res => {
        console.log('invoiceTaskInfo res = ', res)
        if (res.data) {
          // res.data.sameBatchTaskAmount = 3;
          // res.data.invoiceEmailStatus = 0;
          // res.data.invoiceStatus = 1;
          // res.data.emailExceptionMessage = null;
          // res.data.email = '1234dasd';
          // res.data.reSendBtn = true;
          // res.data.emailSuffixList = ['126.com', 'qq.com', '163.con', '138.cn', 'coffee.com'];

          res.data.emailSuffixList = res.data.emailSuffixList?.map(suf => suf.replace('@', ''))

          this.showDetail = true
          this.form = res.data;

          console.log('this.$refs = ', this.$refs);

        }
      }).catch(err => {
        console.log(err)
        console.log('getDetail error', err)
        this.showDetail = false
      }).finally(() => {
        // this.$toast.clear(true)
        this.showLoading = false;
        this.$nextTick(() => {
          this.$refs.formList?.validate();
        });
      })

    },
    handleOrderNumClick() {
      console.log('handleOrderNumClick')
      this.$router.push({path: '/invoice/orders', query: {invoiceNo: this.invoiceNo}})
    },
    // 邮箱后编辑按钮的点击事件
    editBtnAction() {
      console.log('editBtnAction')
      this.editType = 1;
      this.showSheet = true
    },
    sendAgain() {
      console.log('sendAgain')
      if (this.form.invoiceEmailStatus === 1) {
        this.editType = 1;
      } else {
        this.editType = 2;
      }
      this.showSheet = true
      // setTimeout(() => {
      //   this.sendKey++
      // }, 10000)
    },
    emailConfirm() {
      console.log('emailConfirm = ', this.invoiceNo)
      console.log('emailConfirm this.editType = ', this.editType)
      console.log('emailConfirm this.tempEmail = ', this.tempEmail)

      const regExp = /^[a-zA-Z0-9]([a-zA-Z0-9._+-]*[a-zA-Z0-9])?@[a-zA-Z0-9]([a-zA-Z0-9.-]*[a-zA-Z0-9])?\.[a-zA-Z]{2,}$/

      if (!regExp.test(this.tempEmail)) {
        this.$toast.fail('邮箱格式不正确，请重新填写')
        return;
      }

      if (this.editType === 1) {
        if (this.form.sameBatchTaskAmount > 1) {
          this.showDialog = true;
        } else {
          this.editInvoiceEmail(this.form.invoiceNo, null)
        }
      }

      if (this.editType === 2) {
        this.resendEmailAction();
      }

    },
    resendEmailAction() {
      resendEmail({invoiceNo: this.invoiceNo, email: this.tempEmail}).then(res => {
        console.log(res)
        this.showSheet = false
        if (res.data) {
          this.$toast.success('提交成功，请留意查看邮箱')
        } else {
          this.$toast.fail(res.busMessage)
        }
      }).catch(err => {
        console.log(err);
      }).finally(() => {
        this.getDetail();
      });
    },
    editInvoiceEmail(invoiceNo, batchId) {
      const invoiceEmail = this.tempEmail;
      updateInvoice({
        invoiceNo,
        batchId,
        invoiceEmail,
      }).then(res => {
        console.log('updateInvoice res = ', res);
        if (res.busCode === "1") {
          this.showSheet = false
        } else {
          Toast('修改失败，请重试')
        }

      }).catch(err => {
        console.log('err = ', err)
      }).finally(() => {
        this.btn1Loading = false;
        this.btn2Loading = false;
        this.showDialog = false;
        this.getDetail();
      });
    },
    // 判断是否是微信浏览器还是小程序环境
    isMiniProgram() {
      // wx.miniProgram.getEnv是异步，所以封装在Promise中
      return new Promise((resolve) => {
        if (this.isWeixinPlatform) {
          return wx.miniProgram.getEnv((res) => {
            if (res.miniprogram) {
              resolve(true);
            } else {
              resolve(false);
            }
          });
        }
        resolve(false);
      });
    },
  }
}
</script>
<style>
.van-action-sheet__header {
  font-weight: 600;
}

.van-popover--dark {
  right: 26px;
  left: auto !important;
  //background-color: #FFFFFF00;
}

.van-popover--dark .van-popover__arrow {
  color: #00000099;
}

.tool-tip {
  background-color: #00000099;
}

.van-popover--dark .van-popover__content {
  background-color: #FFFFFF00;
}
</style>
<style scoped lang="scss">

:deep(.van-cell::after) {
  border-bottom: none;
}

.page {
  width: 100%;
  height: 100vh;
  background-color: #F5F5F5;
  //background-color: yellow;
  padding-top: 1px;
  overflow-y: scroll;
}

.card-title {
  padding: 20px 66px 4px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 28px;
  color: #5E5E5E;
  line-height: 40px;
  text-align: right;
  font-style: normal;
}

.card {
  background-color: white;
  margin: 24px 32px 32px;
  border-radius: 20px;
  overflow: hidden;

  :deep(.label-class) {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 26px;
    color: #999999;
    line-height: 44px;
    text-align: left;
    font-style: normal;
  }

  :deep(.van-field__control) {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 26px;
    color: #000000;
    line-height: 44px;
    text-align: right;
    font-style: normal;
  }
}

.invoiceMoney {
  :deep(.van-field__control) {
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 26px;
    color: #A52337;
    line-height: 44px;
    text-align: right;
    font-style: normal;
  }
}

.tool-tip {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 22px;
  color: #FFFFFF;
  line-height: 32px;
  text-align: left;
  font-style: normal;
}

.bottom-view {
  background-color: white;
  position: fixed;
  width: 100%;
  bottom: 0;
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);

  .bitton-view {
    height: 80px;
    margin: 16px 32px;
    background-color: #A52337;
    border-radius: 40px;
    color: white;
    text-align: center;
    line-height: 80px;
  }
}

.form-list {
  padding-bottom: calc(constant(safe-area-inset-bottom) + 120px);
  padding-bottom: calc(env(safe-area-inset-bottom) + 120px);
}

.sheet-content {
  height: 100%;
  //justify-content: space-between;
  display: flex;
  flex-direction: column;

  .van-field {
    width: auto;
    background-color: #F9F8F8;
    margin: 0 32px;
    border-radius: 16px;
  }

  .input-box {
    margin-top: 40px;
    background-color: white
  }


}

.bottom-padding {
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
}

.empty-view {
  display: flex;
  flex-direction: column;
  align-items: center;

  .empty-img {
    width: 320px;
    height: 248px;
    margin-top: 396px;
  }

  .empty-text {
    padding-top: 24px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 28px;
    color: #5E5E5E;
    line-height: 40px;
    text-align: right;
    font-style: normal;
  }

  .login-button {
    margin-top: 40px;
  }
}

.tea-price {
  color: #2A2A2A;
}

.img-icon {
  width: 36px;
  height: 36px;
}

.email-line {
  :deep(.van-field__error-message) {
    text-align: right;
    font-weight: 500;
    font-size: 24px;
    color: #A52337;
  }
}

.tc-email-line {
  :deep(.van-field__error-message) {
    text-align: right;
    font-weight: 500;
    font-size: 24px;
    color: #FF3232;
  }
}


.gray-text {
  :deep(.van-field__control) {
    color: #999999;
  }
}

.edit-dialog {
  background-color: white;
  padding: 64px 40px 48px 40px;
  text-align: center;

  .dialog-title {
    font-weight: 500;
    font-size: 28px;
    color: #000000;
    line-height: 48px;
  }

  .btn-line {
    padding-top: 40px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    font-weight: 500;
    font-size: 28px;
    line-height: 80px;
  }

  .dialog-btn1 {
    width: 244px;
    height: 80px;
    color: black;
    background-color: #F1F1F1;
    border-radius: 40px;
    padding: 0;
  }

  .dialog-btn2 {
    width: 244px;
    height: 80px;
    color: white;
    background-color: #A52337;
    border-radius: 40px;
    padding: 0;
  }

}

.bloc-fit {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  position: relative;
}

.btn-box {
  margin: 32px 32px;
}

.suf-line {
  display: flex;
  flex-direction: row;
  overflow: scroll;
  //height: 84px;
  align-items: center;
  background-color: white;
  box-shadow: 0px -2px 8px 0px rgba(0, 0, 0, 0.08);
  //padding: 0 0;

  .suf-item {
    height: 48px;
    line-height: 48px;
    padding: 0 28px;
    border-radius: 24px;
    border: solid rgba(0, 0, 0, 0.6) 2px;
    margin-left: 24px;
    margin-top: 18px;
    margin-bottom: 18px;
  }

  :last-child {
    margin-right: 36px;
  }

  :first-child {
    margin-left: 36px;
  }
}

.email-list {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  background-color: #F9F8F8;
  margin: 8px 32px;
  padding: 0 24px;
  max-height: 196px;
  overflow-y: auto;
  border-radius: 16px;

  .email-list-item {
    height: 60px;
    line-height: 60px;
    font-weight: 400;
    font-size: 28px;
    color: #666666;

    .email-blod {
      font-weight: bold;
      color: #000000;
    }
  }

  :first-child {
    margin-top: 20px;
  }

  :last-child {
    margin-bottom: 20px;
  }

}

.formBottom {
  padding-bottom: calc(constant(safe-area-inset-bottom) + 120px);
  padding-bottom: calc(env(safe-area-inset-bottom) + 120px);
}

:deep(.van-field__clear) {
  width: 38px;
  height: 38px;
  color: #999999;
}

:deep(.van-action-sheet__header) {
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 32px;
  color: #000000;
}

:deep(.van-action-sheet__close) {
  padding: 0 36px;
  color: #999999;
  font-size: 36px;
}

.ic-edit {
  height: 32px;
  width: 32px;
}

.van-cell__right-icon {
  margin-left: 8px;
  color: #969799;
  height: 48px;
  font-size: 32px;
  line-height: 48px;
}

.tc-background-color {
  background-color: #97D700;
}

</style>
